import { render, staticRenderFns } from "./SampleView.vue?vue&type=template&id=358c5dc4"
import script from "./SampleView.vue?vue&type=script&lang=js"
export * from "./SampleView.vue?vue&type=script&lang=js"
import style0 from "./SampleView.vue?vue&type=style&index=0&id=358c5dc4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports